/** What the user supplies when archiving a customer. */
export interface ArchiveCustomerInput {
  /** Required — why this customer is being archived. */
  reason: string
  /**
   * The customer that inherits the archived customer's resources. Required
   * when the customer has services (the server enforces it).
   */
  targetId?: string
  /** Move the customer's notes/documents/revision trail too. Default true. */
  moveNotes?: boolean
  moveDocuments?: boolean
  moveRevisions?: boolean
}

/** Counts of what archiving a customer would touch, by collection. */
export interface CustomerArchivePreview {
  archived: boolean
  /** Number of services-type resources (callouts, sessions, jobs, follow-ups, messages). */
  services: number
  counts: Record<string, number>
}

export const resourceCountLabels: Array<[string, string, string]> = [
  ['callouts', 'callout', 'callouts'],
  ['sessions', 'session', 'sessions'],
  ['jobs', 'job', 'jobs'],
  ['follow_ups', 'follow-up', 'follow-ups'],
  ['whatsapp_messages', 'WhatsApp message', 'WhatsApp messages'],
]

export type ServiceCollectionName = 'callouts' | 'sessions' | 'jobs'

/** Operations that go straight to the backend (they span many collections). */
export interface CustomerArchivePort {
  previewCustomerArchive(customerId: string): Promise<CustomerArchivePreview>
  archiveCustomer(customerId: string, input: ArchiveCustomerInput): Promise<void>
  unarchiveCustomer(customerId: string): Promise<void>
  relinkServiceCustomer(
    collection: ServiceCollectionName,
    serviceId: string,
    customerId: string,
    reason: string,
  ): Promise<void>
}
